(function () {
  'use strict';

  /* ===========================================
     PENNY — Page Transition Loading Overlay
     Editorial Animation:
       1. Black overlay + counter starts immediately
       2. Progress bar fills left→right in sync with counter
       3. Product images cycle (all except first/last, ~250ms each)
       4. Mood text fades in with vertical drift (~60% counter)
       5. Canvas slides up as one unit (unified exit)

     Note: The actual root cause of the Instagram WebView issue
     was the @view-transition CSS rule in base.css, which is
     disabled by view-transitions.js for Instagram/Facebook WebViews.
     The loading overlay itself works correctly.
     =========================================== */

  var hasStarted = false;
  var removed = false;
  var overlay, counter, progressBar, imageEl, text, imageSlides;
  var textRevealed = false;
  var currentSlideIndex = 0;
  var safetyTimer = null;
  var rAFId = null;

  /* --------------- Polyfill: performance.now() --------------- */
  var getNow = (function () {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      return function () { return performance.now(); };
    }
    return function () { return Date.now(); };
  })();

  function getElements() {
    overlay = document.getElementById('penny-loading-overlay');
    counter = document.getElementById('penny-loading-counter');
    progressBar = document.getElementById('penny-loading-progress-bar');
    imageEl = document.getElementById('penny-loading-image');
    text = document.getElementById('penny-loading-text');
    imageSlides = document.querySelectorAll('.penny-loading-overlay__image-slide');
  }

  function safelyRemove() {
    if (removed) return;
    removed = true;
    clearSafetyTimeout();
    if (rAFId) { cancelAnimationFrame(rAFId); rAFId = null; }
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
  }

  function scheduleSafetyTimeout() {
    clearSafetyTimeout();
    var MAX_LOAD_TIME = 8000;
    safetyTimer = setTimeout(function () {
      safelyRemove();
    }, MAX_LOAD_TIME);
  }

  function clearSafetyTimeout() {
    if (safetyTimer) {
      clearTimeout(safetyTimer);
      safetyTimer = null;
    }
  }

  function startPennyLoading() {
    if (hasStarted) return;
    getElements();
    if (!overlay) return;

    hasStarted = true;
    scheduleSafetyTimeout();

    if (counter) counter.textContent = '0';
    if (progressBar) progressBar.style.width = '0%';

    if (imageSlides.length > 0) {
      imageSlides[0].classList.add('is-active');
      overlay.classList.add('penny-loading-overlay--images-visible');

      if (imageSlides.length > 1) {
        startImageCycle();
      }
    } else if (imageEl && imageEl.querySelector('img')) {
      overlay.classList.add('penny-loading-overlay--images-visible');
    }

    startCounter();
  }

  /* ============================================================
     Counter 0→100

     Primary loop: requestAnimationFrame
     Fallback:     if rAF hasn't fired in 200ms, switch to
                   setInterval ticking at ~60fps (16ms).
     Wall clock:   Every tick compares real wall-clock time
                   against start. If wall clock exceeds
                   3.5s, force-exit immediately regardless
                   of animation progress.

     Duration: 1200ms with easeOutQuart deceleration.
     Progress bar fills linearly.
     ============================================================ */
  function startCounter() {
    var startTime = getNow();
    var COUNTER_DURATION = 1200;
    var MAX_SAFE_TIME = 3500;
    var rAFTimeout = null;
    var fallbackInterval = null;
    var usingFallback = false;

    function easeOutQuart(t) {
      return 1 - Math.pow(1 - t, 4);
    }

    function tick() {
      if (removed) return;
      var elapsed = getNow() - startTime;
      var wallTimeExceeded = elapsed >= MAX_SAFE_TIME;

      var t = Math.min(elapsed / COUNTER_DURATION, 1);
      var eased = easeOutQuart(t);
      var val = Math.round(eased * 100);

      if (counter) {
        try { counter.textContent = val; } catch (e) { /* element removed */ }
      }

      if (progressBar) {
        try { progressBar.style.width = Math.round(t * 100) + '%'; } catch (e) { /* elem gone */ }
      }

      if (t >= 0.60 && !textRevealed) {
        textRevealed = true;
        try {
          overlay.classList.add('penny-loading-overlay--text-visible');
        } catch (e) { /* overlay gone */ }
      }

      if (wallTimeExceeded || t >= 1) {
        cleanup();
        setTimeout(function () {
          if (!removed) scheduleSlideUp();
        }, 400);
      } else if (usingFallback) {
        // fallbackInterval is the loop — do nothing, next tick handles it
      } else {
        // rAF loop: clear previous timeout, schedule new rAF
        clearTimeout(rAFTimeout);
        rAFTimeout = setTimeout(function () {
          // rAF didn't fire for 200ms — swich to setInterval fallback
          usingFallback = true;
          clearTimeout(rAFTimeout);
          fallbackInterval = setInterval(function () {
            if (removed) { clearInterval(fallbackInterval); return; }
            tick();
          }, 16);
        }, 200);

        rAFId = requestAnimationFrame(tick);
      }
    }

    function cleanup() {
      clearTimeout(rAFTimeout);
      if (fallbackInterval) { clearInterval(fallbackInterval); fallbackInterval = null; }
      if (rAFId) { cancelAnimationFrame(rAFId); rAFId = null; }
    }

    tick();
  }

  function startImageCycle() {
    var totalSlides = imageSlides.length;

    function advanceImage() {
      if (removed) return;
      var nextIndex = currentSlideIndex + 1;

      if (nextIndex >= totalSlides) return;

      try {
        imageSlides[nextIndex].style.zIndex = currentSlideIndex + 3;
        imageSlides[nextIndex].classList.add('is-active');
      } catch (e) { return; }
      currentSlideIndex = nextIndex;

      setTimeout(advanceImage, 250);
    }

    setTimeout(advanceImage, 250);
  }

  function scheduleSlideUp() {
    if (removed) return;
    clearSafetyTimeout();
    try {
      overlay.style.transition = 'none';
      overlay.style.transform = 'translateY(0)';
      overlay.offsetHeight;
      overlay.style.transition = 'transform 0.55s cubic-bezier(0.4, 0, 0.2, 1)';
      overlay.style.transform = 'translateY(-100%)';
      overlay.classList.add('penny-loading-overlay--slide-up');
    } catch (e) { return; }

    setTimeout(function () {
      if (overlay) {
        overlay.style.transition = '';
        overlay.style.transform = '';
        overlay.offsetHeight;
      }
      safelyRemove();
    }, 600);
  }

  window.startPennyLoading = startPennyLoading;

  function autoInit() {
    getElements();
    if (!overlay) return;
    scheduleSafetyTimeout();
    requestAnimationFrame(function () {
      startPennyLoading();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }

  /* Handle bfcache restores — Instagram WebView aggressively
     uses bfcache. The 'pageshow' event fires after restore.
     Reset state and re-initialize overlay if needed. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      getElements();
      if (!overlay) return;
      // Reset all state for fresh start
      hasStarted = false;
      removed = false;
      textRevealed = false;
      currentSlideIndex = 0;
      autoInit();
    }
  });
})();
